export default __webpack_public_path__ + "static/media/GiftCard.0b374740.svg";